<template>
  <div class="wrap-box" :class="{'selected-box': idx == selectIdx}" @click="onclick">
    <div>주{{idx + 1}}</div>
    <div class="noti_title">{{item.dongNm.trim()}}</div>
    <div>{{item.etcPurps}}</div>
  </div>
</template>

<script>
import moment from "moment";
import Utils from "../../config/utils";
const u = require('util');


export default {
  name: "BrItem",
  props:['item', 'idx', 'selectIdx'],
  components:{
    
  },
  inject: ["eventBus"],
  data() {
    return {
      util: Utils,
      self: this,
      u:u,
      
    }
  },
  computed:{
    
  },
  methods:{
    onclick(){
      this.$emit('click');
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/vars";

.wrap-box{
  background-color: $c_f6f4f4;
  color: $c_525251;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  font-size: $fs_15;
  font-family: $korean_gd_13_r;
  margin-right: 10px;
  align-self: flex-start;
  cursor: pointer;
}

.selected-box {
  background-color: $primary;
  color: $white;
}

.noti_title {
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  margin-top: 2px;
  margin-bottom: 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/controls/BrItem.vue